"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = match;

/* eslint-disable react/function-component-definition, react/destructuring-assignment */
function match(field) {
  return function (value, data) {
    if (data) {
      if (value !== data[field]) {
        return 'Do not match';
      }
    }

    return null;
  };
}